import { render } from "./Chef-index.vue?vue&type=template&id=613980c1"
import script from "./Chef-index.vue?vue&type=script&lang=js"
export * from "./Chef-index.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__